export function initGuideToc() {
  const article = document.querySelector(".guide-article");
  const sections = [...document.querySelectorAll(".guide-section")];
  const thumb = document.querySelector(".guide-rail-thumb");
  if (!article || !sections.length) return;

  const headerOffset = () => {
    const header = document.querySelector(".site-header");
    return (header?.offsetHeight || 76) + 28;
  };

  const setActive = () => {
    const line = window.scrollY + headerOffset();
    let current = sections[0];
    sections.forEach((section) => {
      const heading = section.querySelector("h2") || section;
      const top = heading.getBoundingClientRect().top + window.scrollY;
      if (top <= line + 12) current = section;
    });

    sections.forEach((section) => {
      const on = section === current;
      section.classList.toggle("is-active", on);
      section.querySelector(".guide-index")?.classList.toggle("is-active", on);
    });

    const articleBox = article.getBoundingClientRect();
    const sectionBox = current.getBoundingClientRect();
    thumb.style.top = `${sectionBox.top - articleBox.top}px`;
    thumb.style.height = `${current.offsetHeight}px`;
  };

  setActive();
  window.addEventListener("scroll", setActive, { passive: true });
  window.addEventListener("resize", setActive);
}
